<template>
  <div class="filter-modal" @click="$emit('close')">
    <div class="filter-modal-content" data-analytics_available_call="0" @click.stop>
      <!-- Opzioni di filtro -->
      <div class="filter-section">
        <div v-if="appliedFilter.length > 0" class="filter-summary">
          <Bean v-for="(singleBean, index) in appliedFilter" :singleFilter="singleBean" />
        </div>

        <FilterOption v-for="(facet, index) in facetList" :key="index" :entries="facet.entry" :name="facet.name"
          :filterLabel="facet.label" :type="facet.type" :index="index" :openIndex="openIndex" :value="facet.value"
          @updateOpenIndex="updateOpenIndex" />
      </div>

      <div class="bottom-modal-container">
        <div class="clearAll-button" @click="resetFilters">Clear All</div>
        <button @click="applyFilters" class="apply-button">see {{ totalFilterResult }} results</button>
        <CloseArrowIcon @click="$emit('close')" />
      </div>

    </div>
  </div>
</template>

<script>
import Bean from "../Bean/Bean.ts";
import FilterModal from "./FilterModal.ts";
export default {
  ...FilterModal,
};
</script>
<style lang="scss">
@import "./FilterModal.scss";
</style>